







import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import DevConsole from './DevConsole'

settings =
  name: 'App'
  vue: 
    store: ['member']

    components: {
      DevConsole,
    }

    mounted: ->
      return @$router.push({name: 'Browser'}) if @isMicrosoftBrowser()
      @loadStash()
      @setCurrentMember(@member) if @member?.token?
      if !@member?.token?
        # redirect if not one of our expected non-auth routes
        @navigateToDashboard() if !@isPublicRoute && !@isPartnerBuyRoute
      @getMarketplaceConfig()
      # @$intercom.boot() if @$intercom?

    computed:
      publicRoutes: -> ['login', 'register', 'forgot', 'reset', 'invitation', 'shared', 'browser', 'status', 'maintenance', 'store', 'organizer-recaps']
      isPublicRoute: ->
        currentPath = window.location.href.replace(window.location.origin, '')
        @publicRoutes.some (v) -> currentPath.includes(v)
      isPartnerBuyRoute: ->
        @isPartnerBuy()

    methods:
      getMarketplaceConfig: ->
        await @fetchMarketplaceConfig()
        @$router.replace({ name: 'Maintenance' }) if @isOnMaintenanceMode()

export default VueOptions.vue settings
